// extracted by mini-css-extract-plugin
export default {"row__status":"ProductProposalsTable_row__status__Xb-ho"};